
<span class="icon" :class="[sizeClassName]">
  {{ iconText }}
</span>
